import {createApiService} from "../http";
import { IUserData, IUser, UserGetAllRequest, UserLoginRequest, UserRegistrationRequest, UserResetPasswordFinal, UserUpdateDataRequest, UserUpdatePasswordRequest, UserSearchForLoginMatch } from "../types/services-types/user-types";

export default class UserService {

    static apiUserService = createApiService('/user')


    static async Login(data: UserLoginRequest) {
        const response = await this.apiUserService.post<IUserData>('/login', data)
        return response.data
    }

    static async Registration(data: UserRegistrationRequest) {
        const response = await this.apiUserService.post<IUserData>('/registration', data)
        return response.data
    }

    static async Logout() {
        const response = await this.apiUserService.get('/logout')
        return response.data
    }

    static async Refresh() {
        const response = await this.apiUserService.get<IUserData>('/refresh')
        return response.data
    }

    static async Get(id: string | number) {
        const response = await this.apiUserService.get<IUser>(`/${id}`)
        return response.data
    }

    static async GetAll(data: UserGetAllRequest) {
        const response = await this.apiUserService.get<IUser[]>('/all', {
            params: data
        })
        return response.data
    }

    static async UpdatePassword(data: UserUpdatePasswordRequest) {
        const response = await this.apiUserService.post('/update-password', data)
        return response.data
    }

    static async Update(data: UserUpdateDataRequest) {
        const response = await this.apiUserService.post<IUser>('/update', data)
        return response.data
    }

    static async ResetPasswordRequest(email: string) {
        const response = await this.apiUserService.post('/reset-password', {email})
        return response.data
    }

    static async ResetPasswordFinal(data: UserResetPasswordFinal) {
        const response = await this.apiUserService.post<IUser>('/reset-password-finish', data)
        return response.data
    }

    static async GetUserForLoginMatch(search: string, limit: number | string, page: number | string) {
        const response = await this.apiUserService.get<UserSearchForLoginMatch>('/search-user-for-login', {
            params: {
                search,
                limit,
                page
            }
        })
        return response.data
    }

    static async AddPersonData(first_name, second_name, sur_name, document_person, series_number_passport, date_issue_passport, whom_issue_passport, place_of_residence) {
        const response = await this.apiUserService.post(`/add-person-data`, {
            first_name, second_name, sur_name, document_person, series_number_passport, date_issue_passport, whom_issue_passport, place_of_residence
        })
        return response.data
    }

    static async SetStatusJoiningService() {
        const response = await this.apiUserService.get(`/set-status-joining-service`)
        return response.data
    }

    static async UnsetStatusJoiningService() {
        const response = await this.apiUserService.get(`/unset-status-joining-service`)
        return response.data
    }

}